var heroCarouselStyle = {
    dots: false,
    arrows: true,
    infinite: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1500,
    autoplaySpeed: 6000,
    pauseOnHover: false,
};

export default heroCarouselStyle;